"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTCategory = void 0;
const validation_1 = require("../validation");
var NFTCategory;
(function (NFTCategory) {
    NFTCategory["WEARABLE"] = "wearable";
    NFTCategory["ACCESSORIES"] = "accessories";
    NFTCategory["ATHLETICS"] = "athletics";
    NFTCategory["FOOD"] = "food";
    NFTCategory["ANIMALS"] = "animals";
})(NFTCategory = exports.NFTCategory || (exports.NFTCategory = {}));
(function (NFTCategory) {
    NFTCategory.schema = {
        type: 'string',
        enum: Object.values(NFTCategory),
    };
    NFTCategory.validate = validation_1.generateValidator(NFTCategory.schema);
})(NFTCategory = exports.NFTCategory || (exports.NFTCategory = {}));
//# sourceMappingURL=nft-category.js.map